import EngineFamily from "../../engineFamily/pages";
import requireAuth from "../../../../utils/requireAuth"
import AircraftFamily from "../../aircraftFamily/pages";
import Region from "../../region/pages"
import AircraftModels from "../../aircraftModels/pages"
import ApuTypes from "../../apuTypes/pages";
import EngineTypes from "../../engineTypes/pages";
import AircraftTypes from "../../aircraftTypes/pages";
import Manufacturers from "../../manufacturers/pages"
import LgSubAssemblies from "../../lgSubAssemblies/pages"
import EngineLlpsConfig from "../../engineLlpsConfig/pages"
import MaintenancePrograms from "../../maintenancePrograms/pages"
import AircraftTypeView from "../../aircraftTypes/component/AircraftTypeView";
import EngineFamilyView from "../../engineFamily/component/EngineFamilyView";
import EngineTypeView from "../../engineTypes/components/EngineTypeView";
import LlpPartView from "../../engineLlpsConfig/components/LlpPartView";
import ApuTypeView from "../../apuTypes/components/ApuTypeView";

export const configRoute = [
    {
        path:'config-data/aircraftTypes',
        component:requireAuth(AircraftTypes),
        key:'aircraftTypes'
    },
    {
        path:'config-data/engineTypes',
        component:requireAuth(EngineTypes),
        key:'engineTypes'
    },
    {
        path:'config-data/engineFamily',
        component:requireAuth(EngineFamily),
        key:'engineFamily'
    },
    {
        path:'config-data/aircraftFamily',
        component:requireAuth(AircraftFamily),
        key:'aircraftFamily'
    },
    {
        path:'config-data/region',
        component:requireAuth(Region),
        key:'region'
    },
    {
        path:'config-data/aircraftModels',
        component:requireAuth(AircraftModels),
        key:'aircraftModels'
    },
    {
        path:'config-data/apuTypes',
        component:requireAuth(ApuTypes),
        key:'engineTypes'
    },
    {
        path:'config-data/manufacturers',
        component:requireAuth(Manufacturers),
        key:'manufacturers'
    },
    {
        path:'config-data/lgSubAssemblies',
        component:requireAuth(LgSubAssemblies),
        key:'lgSubAssemblies'
    },
    {
        path:'config-data/engineLlpsConfig',
        component:requireAuth(EngineLlpsConfig),
        key:'engineLlpsConfig'
    },
    {
        path:'config-data/maintenancePrograms',
        component:requireAuth(MaintenancePrograms),
        key:'maintenancePrograms'
    },
    {
        path:'config-data/aircraftTypes/View/:id',
        component:requireAuth(AircraftTypeView),
        key:'aircraftTypeView'
    },
    {
        path:'config-data/engineFamily/View/:id',
        component:requireAuth(EngineFamilyView),
        key:'engineFamilyView'
    },
    {
        path:'config-data/engineType/View/:id',
        component:requireAuth(EngineTypeView),
        key:'engineTypeView'
    },
    {
        path:'config-data/engineLlpsConfig/llpPart/View/:id',
        component:requireAuth(LlpPartView),
        key:'llpPartView'
    },
    {
        path:'config-data/apuTypes/View/:id',
        component:requireAuth(ApuTypeView),
        key:'apuTypeView'
    },

]